import { BaseIllustration, BaseIllustrationProps } from '../BaseIllustration';

export type HandoverIllustrationProps = Omit<BaseIllustrationProps, 'children'>;

export const HandoverIllustration = ({ ...props }: HandoverIllustrationProps) => (
  <BaseIllustration width="64" height="64" viewBox="0 0 64 64" {...props}>
    <g strokeWidth={2} fill="none" strokeLinecap="square">
      <circle cx="11" cy="14" r="7" strokeLinecap="butt" />
      <path d="M28,40C18,35,18,26,10,26a8.18,8.18,0,0,0-8,8V57H18V41" />
      <circle cx="53" cy="14" r="7" strokeLinecap="butt" />
      <path d="M36,40c10-5,10-14,18-14a8.18,8.18,0,0,1,8,8V57H46V41" />
    </g>
  </BaseIllustration>
);

HandoverIllustration.displayName = 'HandoverIllustration';
